// extracted by mini-css-extract-plugin
export default {"authFooter":"AuthFooter_authFooter__bAmVj"};